import '../assets/NcDialog-DEKSpcnR.css';
import { useElementSize as m } from "@vueuse/core";
import { defineComponent as y, ref as s, computed as n } from "vue";
import C from "../Components/NcModal.mjs";
import { N as b } from "./NcDialogButton-DQFoaN7q.mjs";
import { G as A } from "./GenRandomId-BW3iYFf9.mjs";
import { n as h } from "./_plugin-vue2_normalizer-Bj5bLKV4.mjs";
const N = y({
  name: "NcDialog",
  components: {
    NcDialogButton: b,
    NcModal: C
  },
  props: {
    /** Name of the dialog (the heading) */
    name: {
      type: String,
      required: !0
    },
    /** Text of the dialog */
    message: {
      type: String,
      default: ""
    },
    /** Additional elements to add to the focus trap */
    additionalTrapElements: {
      type: Array,
      validator: (e) => Array.isArray(e) && e.every(
        (a) => typeof a == "string" || a instanceof HTMLElement
      ),
      default: () => []
    },
    /**
     * The element where to mount the dialog, if `null` is passed the dialog is mounted in place
     * @default 'body'
     */
    container: {
      type: String,
      required: !1,
      default: "body"
    },
    /**
     * Whether the dialog should be shown
     * @default true
     */
    open: {
      type: Boolean,
      default: !0
    },
    /**
     * Size of the underlying NcModal
     * @default 'small'
     * @type {'small'|'normal'|'large'|'full'}
     */
    size: {
      type: String,
      required: !1,
      default: "small",
      validator: (e) => typeof e == "string" && ["small", "normal", "large", "full"].includes(e)
    },
    /**
     * Buttons to display
     * @default []
     */
    buttons: {
      type: Array,
      required: !1,
      default: () => [],
      validator: (e) => Array.isArray(e) && e.every((a) => typeof a == "object")
    },
    /**
     * Set to false to no show a close button on the dialog
     * @default true
     */
    canClose: {
      type: Boolean,
      default: !0
    },
    /**
     * Close the dialog if the user clicked outside of the dialog
     * Only relevant if `canClose` is set to true.
     */
    closeOnClickOutside: {
      type: Boolean,
      default: !1
    },
    /**
     * Declare if hiding the modal should be animated
     * @default false
     */
    outTransition: {
      type: Boolean,
      default: !1
    },
    /**
     * Optionally pass additionaly classes which will be set on the navigation for custom styling
     * @default ''
     * @example
     * ```html
     * <DialogBase :navigation-classes="['mydialog-navigation']"><!-- --></DialogBase>
     * <!-- ... -->
     * <style lang="scss">
     * :deep(.mydialog-navigation) {
     *     flex-direction: row-reverse;
     * }
     * </style>
     * ```
     */
    navigationClasses: {
      type: [String, Array, Object],
      required: !1,
      default: ""
    },
    /**
     * aria-label for the dialog navigation.
     * Use it when you want to provide a more meaningful label than the dialog name.
     *
     * By default, navigation is labeled by the dialog name.
     */
    navigationAriaLabel: {
      type: String,
      required: !1,
      default: ""
    },
    /**
     * aria-labelledby for the dialog navigation.
     * Use it when you have an implicit navigation label (e.g. a heading).
     *
     * By default, navigation is labeled by the dialog name.
     */
    navigationAriaLabelledby: {
      type: String,
      required: !1,
      default: ""
    },
    /**
     * Optionally pass additionaly classes which will be set on the content wrapper for custom styling
     * @default ''
     */
    contentClasses: {
      type: [String, Array, Object],
      required: !1,
      default: ""
    },
    /**
     * Optionally pass additionaly classes which will be set on the dialog itself
     * (the default `class` attribute will be set on the modal wrapper)
     * @default ''
     */
    dialogClasses: {
      type: [String, Array, Object],
      required: !1,
      default: ""
    }
  },
  emits: ["closing", "update:open"],
  setup(e, { emit: a, slots: t }) {
    const i = s(), { width: l } = m(i, { width: 900 }), u = n(() => l.value < 876), f = n(() => (t == null ? void 0 : t.navigation) !== void 0), r = s(A()), g = n(() => e.navigationAriaLabel || void 0), p = n(() => {
      if (!e.navigationAriaLabel)
        return e.navigationAriaLabelledby || r.value;
    }), o = s(!0), _ = () => {
      d(), window.setTimeout(() => c(), 300);
    }, d = () => {
      o.value = !1, a("closing");
    }, c = () => {
      o.value = !0, a("update:open", !1);
    }, v = n(() => ({
      canClose: e.canClose,
      container: e.container === void 0 ? "body" : e.container,
      // we do not pass the name as we already have the name as the headline
      // name: props.name,
      size: e.size,
      show: e.open && o.value,
      outTransition: e.outTransition,
      closeOnClickOutside: e.closeOnClickOutside,
      additionalTrapElements: e.additionalTrapElements
    }));
    return {
      handleButtonClose: _,
      handleClosing: d,
      handleClosed: c,
      hasNavigation: f,
      navigationId: r,
      navigationAriaLabelAttr: g,
      navigationAriaLabelledbyAttr: p,
      isNavigationCollapsed: u,
      modalProps: v,
      wrapper: i
    };
  }
});
var w = function() {
  var a = this, t = a._self._c;
  return a._self._setupProxy, a.open ? t("NcModal", a._b({ staticClass: "dialog__modal", attrs: { "enable-slideshow": !1, "enable-swipe": !1 }, on: { close: a.handleClosed, "update:show": a.handleClosing } }, "NcModal", a.modalProps, !1), [t("h2", { staticClass: "dialog__name", attrs: { id: a.navigationId }, domProps: { textContent: a._s(a.name) } }), t("div", { staticClass: "dialog", class: a.dialogClasses }, [t("div", { ref: "wrapper", class: ["dialog__wrapper", { "dialog__wrapper--collapsed": a.isNavigationCollapsed }] }, [a.hasNavigation ? t("nav", { staticClass: "dialog__navigation", class: a.navigationClasses, attrs: { "aria-label": a.navigationAriaLabelAttr, "aria-labelledby": a.navigationAriaLabelledbyAttr } }, [a._t("navigation", null, { isCollapsed: a.isNavigationCollapsed })], 2) : a._e(), t("div", { staticClass: "dialog__content", class: a.contentClasses }, [a._t("default", function() {
    return [t("p", { staticClass: "dialog__text" }, [a._v(" " + a._s(a.message) + " ")])];
  })], 2)]), t("div", { staticClass: "dialog__actions" }, [a._t("actions", function() {
    return a._l(a.buttons, function(i, l) {
      return t("NcDialogButton", a._b({ key: l, on: { click: a.handleButtonClose } }, "NcDialogButton", i, !1));
    });
  })], 2)])]) : a._e();
}, L = [], S = /* @__PURE__ */ h(
  N,
  w,
  L,
  !1,
  null,
  "b0b5e355",
  null,
  null
);
const z = S.exports;
export {
  z as N
};
